import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { RootScopeService } from '../../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../../core/rootscope-declare';
import { environment } from '../../../../environments/environment';
import { FacilityDetailsService } from '../../services/facility-details.service';
import { FacilityService } from 'src/app/core/services/facility.service';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-halomedia-announcement-modal',
  templateUrl: './halomedia-announcement-modal.component.html',
  styleUrls: ['./halomedia-announcement-modal.component.css'],
})
export class HalomediaAnnouncementModalComponent implements OnInit, OnDestroy {
  cloudBasePath: string;
  rootScopeData: RootScopeDeclare;
  currentFacility: FacilityObject;

  @Output() onClose: EventEmitter<any> = new EventEmitter();

  // subscriptions
  private _facilityOnChange: Subscription;

  constructor(
    private rootScopeService: RootScopeService,
    private facilityDetailService: FacilityDetailsService,
    private _facilityService: FacilityService,
    private router: Router
  ) { }

  ngOnInit() {
    this.cloudBasePath = environment.cloudBasePath;
    this.getRootScopeData();

    // subscript facility change / when facility change
    this.currentFacility = this._facilityService.selectedFacility();
    this._facilityOnChange = this._facilityService.selectedFacilitySource.subscribe(res => {
      this.currentFacility = res;
    });
  }

  ngOnDestroy() {
    // distryo subscriber
    if (this._facilityOnChange) {
      this._facilityOnChange.unsubscribe();
    }
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => {
      this.rootScopeData = rootScopeData;
    });
  }
  updateHideHaloMediaModal(goToScreen: string) {
    if (goToScreen === 'attractscreen') {
      this.router.navigate(['/equipmentSettings/attractscreen']);
      this.onClose.emit({isNavigated: true});
    } else {      
      this.onClose.emit();
    }
    this.rootScopeData.popupData.showHalomediaPopup  = false;
  }
}
